webpackJsonp([141636136906604],{

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['width: 100%;'], ['width: 100%;']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: grid;\n  display: grid;\n  grid-auto-rows: 1fr;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-column-gap: 1rem;\n  position: relative;\n  min-width: 1000px;\n  margin: 4rem 0 0;\n'], ['\n  display: grid;\n  display: grid;\n  grid-auto-rows: 1fr;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-column-gap: 1rem;\n  position: relative;\n  min-width: 1000px;\n  margin: 4rem 0 0;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  height: 500px;\n  position: relative;\n  text-align: center;\n'], ['\n  height: 500px;\n  position: relative;\n  text-align: center;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  margin: 2rem auto;\n  text-align: center;\n'], ['\n  margin: 2rem auto;\n  text-align: center;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80%;\n  margin: 20% 0 0 0;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  > li {\n    margin: 0 2rem;\n\n    > label {\n      padding: 1rem;\n      text-align: center;\n    }\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80%;\n  margin: 20% 0 0 0;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  > li {\n    margin: 0 2rem;\n\n    > label {\n      padding: 1rem;\n      text-align: center;\n    }\n  }\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n  height: 398px;\n  width: 200px;\n  display: flex;\n  flex-direction: row;\n'], ['\n  height: 398px;\n  width: 200px;\n  display: flex;\n  flex-direction: row;\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n  height: 398px;\n  width: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  > label {\n    margin: 1px 0;\n  }\n'], ['\n  height: 398px;\n  width: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n\n  > label {\n    margin: 1px 0;\n  }\n']),
	    _templateObject9 = _taggedTemplateLiteralLoose(['\n  width: 20px;\n  background: black;\n'], ['\n  width: 20px;\n  background: black;\n']),
	    _templateObject10 = _taggedTemplateLiteralLoose(['\n  background: white !important;\n  border: 1px dashed lightBlue;\n  border-left: none;\n  width: 140px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  background: white !important;\n  border: 1px dashed lightBlue;\n  border-left: none;\n  width: 140px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
	    _templateObject11 = _taggedTemplateLiteralLoose(['\n  width: 60px;\n  background: hotpink;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  width: 60px;\n  background: hotpink;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']),
	    _templateObject12 = _taggedTemplateLiteralLoose(['\n  margin-top: 3rem !important;\n  background: lightBlue;\n  position: relative;\n  width: 120px;\n\n  &::after {\n    content: url(', ');\n    display: block;\n    position: absolute;\n    right: -52px;\n    top: 50%;\n    width: 60px;\n    margin-top: -30px;\n  }\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    left: -200px;\n    top: 50%;\n    height: 2px;\n    width: 200px;\n    background: hotpink;\n    opacity: 0.5;\n  }\n'], ['\n  margin-top: 3rem !important;\n  background: lightBlue;\n  position: relative;\n  width: 120px;\n\n  &::after {\n    content: url(', ');\n    display: block;\n    position: absolute;\n    right: -52px;\n    top: 50%;\n    width: 60px;\n    margin-top: -30px;\n  }\n\n  &::before {\n    content: \'\';\n    display: block;\n    position: absolute;\n    left: -200px;\n    top: 50%;\n    height: 2px;\n    width: 200px;\n    background: hotpink;\n    opacity: 0.5;\n  }\n']),
	    _templateObject13 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80%;\n  margin: 20% 0 0 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  > li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin: 0 auto;\n    padding: 20px 10px;\n\n    position: relative;\n\n    &::after {\n      content: url(', ');\n      display: block;\n      position: absolute;\n      right: -42px;\n      top: 50%;\n      width: 60px;\n      margin-top: -30px;\n    }\n\n    > div {\n      display: inline-block;\n      width: 80%;\n      background: lightBlue;\n      padding: 1rem;\n      text-align: center;\n\n    }\n    > label {\n      display: inline-block;\n      width: 20%;\n      text-align: right;\n      padding-right: 2rem;\n    }\n  }\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 80%;\n  margin: 20% 0 0 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  > li {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin: 0 auto;\n    padding: 20px 10px;\n\n    position: relative;\n\n    &::after {\n      content: url(', ');\n      display: block;\n      position: absolute;\n      right: -42px;\n      top: 50%;\n      width: 60px;\n      margin-top: -30px;\n    }\n\n    > div {\n      display: inline-block;\n      width: 80%;\n      background: lightBlue;\n      padding: 1rem;\n      text-align: center;\n\n    }\n    > label {\n      display: inline-block;\n      width: 20%;\n      text-align: right;\n      padding-right: 2rem;\n    }\n  }\n']),
	    _templateObject14 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 4rem auto;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 4rem auto;\n  align-items: center;\n']),
	    _templateObject15 = _taggedTemplateLiteralLoose(['\n  width: 200px;\n  margin: 0 0 1rem 0;\n  padding: 1rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  border-color: ', ';\n'], ['\n  width: 200px;\n  margin: 0 0 1rem 0;\n  padding: 1rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  border-color: ', ';\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Card = __webpack_require__(42);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Components
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	var Img = _styledComponents2.default.img(_templateObject2);
	
	var ArchitectureWrapper = _styledComponents2.default.section(_templateObject3);
	
	var ArchSection = _styledComponents2.default.div(_templateObject4);
	
	var Heading = _styledComponents2.default.h2(_templateObject5);
	
	var BuildList = _styledComponents2.default.ul(_templateObject6);
	
	var GatsbyListItem = _styledComponents2.default.li(_templateObject7);
	
	var ReactListItem = _styledComponents2.default.li(_templateObject8);
	var GraphQL = _styledComponents2.default.div(_templateObject9);
	
	var GatsbyLabel = _styledComponents2.default.label(_templateObject10);
	
	var GraphQLLabel = _styledComponents2.default.label(_templateObject11);
	
	var PageTemplateLabel = _styledComponents2.default.label(_templateObject12, (0, _gatsbyLink.withPrefix)('/images/arrow-right.svg'));
	
	var SourcesList = _styledComponents2.default.ul(_templateObject13, (0, _gatsbyLink.withPrefix)('/images/arrow-right.svg'));
	
	var PagesList = _styledComponents2.default.ul(_templateObject14);
	
	var PageItem = _styledComponents2.default.li(_templateObject15, function (props) {
	  return props.themeColors[0];
	});
	
	var StandaloneArchPage = function StandaloneArchPage(_ref) {
	  var data = _ref.data;
	
	
	  var grouped = _lodash2.default.groupBy(data.allSitePage.edges, function (e) {
	    return e.node.context && e.node.context.type ? e.node.context.type : 'page';
	  });
	
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Architecture'
	    ),
	    _react2.default.createElement(
	      ArchitectureWrapper,
	      null,
	      _react2.default.createElement(
	        ArchSection,
	        null,
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Content'
	        ),
	        _react2.default.createElement(
	          SourcesList,
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Markdown (local)'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Nutrition Pages'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'JSON (local)'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              'Config, RDA Data, Search Index'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'APIs'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Foods, Diets, Nutrients'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '(Sheets API & USDA API)'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ArchSection,
	        null,
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Build'
	        ),
	        _react2.default.createElement(
	          BuildList,
	          null,
	          _react2.default.createElement(
	            GatsbyListItem,
	            null,
	            _react2.default.createElement(
	              GraphQLLabel,
	              null,
	              'GraphQL'
	            ),
	            _react2.default.createElement(
	              GatsbyLabel,
	              null,
	              'Gatsby'
	            )
	          ),
	          _react2.default.createElement(
	            ReactListItem,
	            null,
	            _react2.default.createElement(
	              PageTemplateLabel,
	              null,
	              'NutritionPage.jsx'
	            ),
	            _react2.default.createElement(
	              PageTemplateLabel,
	              null,
	              'index.js'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Component'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Component'
	            ),
	            _react2.default.createElement(
	              PageTemplateLabel,
	              null,
	              'FoodPage.jsx'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Component'
	            ),
	            _react2.default.createElement(
	              'label',
	              null,
	              'Component'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        ArchSection,
	        null,
	        _react2.default.createElement(
	          Heading,
	          null,
	          'Deploy'
	        ),
	        _react2.default.createElement(
	          PagesList,
	          null,
	          _lodash2.default.take(grouped.food, 8).map(function (_ref2) {
	            var node = _ref2.node;
	            return _react2.default.createElement(
	              PageItem,
	              { key: node.id, themeColors: node.context.content.themecolor.split('-') },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: node.path },
	                node.path,
	                '.html'
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = StandaloneArchPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jamstack-architecture-js-0883cddb7c4a5c507302.js